export default __webpack_public_path__ + "static/RTG_PDP_LOGO_BEAUTYREST_BLK_240x100-9714e91c94812215fd88bedbbcf0100a.png";